import "soonCSS";
import "../../css/components/Counter.scss";

import React, { Fragment, useEffect, useRef, useState } from "react";
import Soon from "soonJS";
import styled from "styled-components";

import g from "../utils/globals";

import Header from "./CounterHeader";
import Link from "./Link";

const calculateRelativeFontSize = (fontSize, base) => {
  const baseWidth = g.channels.mobile ? 375 : 1280;
  return (fontSize * 100) / (base || baseWidth);
};
const capitalizeString = string => string.charAt(0).toUpperCase() + string.slice(1);
const hexToRgbA = (hex, alpha = 1) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",")}, ${alpha})`;
  }
  return "rgba(0,0,0, 1)";
};

const createCountdown = () => {
  document.querySelectorAll(".soon").forEach(elm => {
    Soon.create(elm);
  });
};

const Counter = ({ position, analytics, carousel, data, children }) => {
  const StyledCounterWrapper = styled.div`
    > div#soon-counter {
      font-family: ${({ data }) => (data.font ? capitalizeString(data.font) : "Apercu")};
      background-color: ${({ data }) => hexToRgbA(data.backgroundColor, data.backgroundOpacity) || "#000000"};
      .soon-flip-face {
        background-color: ${({ data }) => hexToRgbA(data.backgroundColor, data.backgroundOpacity) || "#000000"};
      }
      span.soon-text.soon-label {
        color: ${({ data }) => data.textUnitsColor || "#ffffff"} !important;
        font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize) / 4.5 : 2)}vw;
      }
      span.soon-flip-face,
      span.soon-separator {
        color: ${({ data }) => data.textDigitsColor || "#ffffff"} !important;
      }
      span.soon-group.soon-group-sub-sub.soon-value,
      .soon-separator {
        font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize) : 9)}vw;
      }
      @media (max-width: 991px) and (orientation: landscape) {
        #counter-title {
          font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize, 991) : 4.5)}vw;
        }
        span.soon-group.soon-group-sub-sub.soon-value,
        .soon-separator {
          font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize, 991) : 10)}vw;
        }
        span.soon-text.soon-label {
          font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize, 991) / 4 : 3.5)}vw;
        }
      }
      @media (max-width: 991px) and (orientation: portrait) {
        span.soon-group.soon-group-sub-sub.soon-value,
        .soon-separator {
          font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize) / 2.5 : 12)}vw;
        }
        span.soon-text.soon-label {
          font-size: ${({ data }) => (data.fontSize ? calculateRelativeFontSize(data.fontSize) / 7.5 : 4)}vw;
        }
      }
    }
  `;
  const counter = useRef();
  const goalTime = new Date(data.countdownTimer.goalTime);
  const [beforeTime, setBeforeTime] = useState(goalTime - Date.now() > 0);
  useEffect(() => {
    if (counter.current) createCountdown(counter.current, data);
    if (beforeTime) {
      const timeLeft = goalTime.getTime() - new Date().getTime() + 1000;
      let timeTrigger = setTimeout(() => {
        setBeforeTime(false);
      }, timeLeft);
      return () => clearTimeout(timeTrigger);
    }
  }, [beforeTime]);
  const itemWithAttrs = children.find(child => child.props.targetUrl);
  if (beforeTime) {
    return (
      <Fragment>
        <StyledCounterWrapper id="counterWrapper" ref={counter} data={data}>
          <div
            className="soon"
            id="soon-counter"
            data-due={data.countdownTimer.goalTime}
            data-padding-days="00"
            data-layout="group adjacent label-uppercase label-big"
            data-scale-max="xx1"
            data-separator=":"
            data-format="d,h,m,s"
            data-separate-chars="false"
            data-face="flip color-dark shadow-soft"
            data-labels-days="DAY,DYS"
            data-labels-hours="HOUR,HRS"
            data-labels-minutes="MNT,MNTS"
            data-labels-seconds="SCND,SCNDS"
          >
            <Header title={data.title} collection={data.collection} />
            <span className="soon-placeholder" />
          </div>
        </StyledCounterWrapper>
        {data.targetUrl && data.countdownTimer.contentClickable && (
          <Link
            id="linkCounter"
            dataAttrs={itemWithAttrs ? itemWithAttrs.props.dataAttrs : {}}
            position={position}
            carousel={carousel}
            analytics={analytics}
            href={data.targetUrl}
          />
        )}
        {children}
      </Fragment>
    );
  }
  return children;
};

export default Counter;
